import React, { useState } from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider, useQuery } from '@apollo/react-hooks';
import styled from 'styled-components';
import { gql } from 'apollo-boost';
import { Row, Col, Card, Skeleton, Drawer, Button } from 'antd';
import LazyLoad from 'react-lazyload';

import { SecondarySectionTitle, Title } from '../../../components/styles';
import Layout from '../../../components/layout';
import { SettingProvider } from '../../../lib/context/settings';
import { AdsProvider } from '../../../lib/context/ads';
import { device } from '../../../lib/theme';
import { typeFromAST } from 'graphql';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const Hero = styled.div`
  background-image: url('/img/automotive/roadside_affiliate-hero.jpg');
  background-position: center center;
  background-size: cover;
  min-height: 300px;
  margin-bottom: 48px;
`;

const renderTypeForm = (
  typeFormURL = 'https://form.typeform.com/to/V6hzKI7B?typeform-medium=embed-snippet'
) => (
  <iframe
    id="typeform-full"
    width="100%"
    height="100%"
    frameBorder="0"
    allow="camera; microphone; autoplay; encrypted-media;"
    src={typeFormURL}
  ></iframe>
);

const AffiliateContent: React.FC<any> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [typeFormURL, setTypeFormURL] = useState<string>('');

  const onClose = () => setVisible(false);
  const showForm = (url) => {
    setVisible(true);
    setTypeFormURL(url);
  };

  return (
    <div>
      <Hero />
      <Row>
        <Col xs={{ span: 22, offset: 1 }} xl={{ span: 20, offset: 2 }}>
          <Title>Become an AAA Affiliate</Title>
          <p style={{ marginTop: 16 }}>
            In our efforts to provide excellent service to our members, we
            partner with quality auto repair, auto body and towing providers
            throughout the Carolinas. If you would like to become an approved
            AAA provider, you can submit your application online.{' '}
            <strong>
              Applicants must be able to provide services in North and South
              Carolina.
            </strong>
          </p>

          <Button
            size="large"
            type="primary"
            onClick={() =>
              showForm(
                'https://form.typeform.com/to/V6hzKI7B?typeform-medium=embed-snippet'
              )
            }
            style={{ marginRight: 8 }}
          >
            Towing Roadside Service Affiliate
          </Button>

          <Button
            size="large"
            type="primary"
            onClick={() =>
              showForm(
                'https://form.typeform.com/to/FpR8EPtw?typeform-medium=embed-snippet'
              )
            }
            style={{ marginRight: 8 }}
          >
            Auto Repair Affiliate
          </Button>

          <Button
            size="large"
            type="primary"
            onClick={() =>
              showForm(
                'https://form.typeform.com/to/LwrukfBx?typeform-medium=embed-snippet'
              )
            }
          >
            Auto Body Affiliate
          </Button>

          <p style={{ marginTop: 32 }}>
            Once received, we will review your application. In order for our
            affiliate’s relationship to be advantageous, AAA Carolinas is
            careful to ensure an appropriate number of contractors/facilities
            for a given area.
            <br />
            <br /> If there is no immediate need in your area, your application
            will remain on file. Should anything become available, we will reach
            out to you. Again, thank you for your interest in joining the AAA
            Carolina’s network!
            <br />
            <br /> If you prefer, you can download the application form and fax
            or mail it in.
          </p>
          <p>
            <strong>Download the Application:</strong>
            <br />
            <a href="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/docs/automotive/ERSform.pdf">
              Towing/Roadside Service Affiliate Application
            </a>
            <br />
            <a href="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/docs/automotive/AARform.pdf">
              Auto Repair Affiliate Application
            </a>
            <br />
            <a href="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/docs/automotive/AABform.pdf">
              Auto Body Affiliate Application
            </a>
            <br />
            <br />
            <strong>Submit by Fax:</strong>
            <br />
            704-569-7804
            <br />
            <br />
            <strong>Submit by Mail:</strong>
            <br />
            <br />
            ATTN: ERS
            <br />
            AAA Carolinas
            <br />
            6600 AAA Drive
            <br />
            Charlotte, NC 28212
          </p>
          <br />
          <br />
        </Col>
      </Row>

      <Drawer
        width="90%"
        placement="left"
        closable={true}
        onClose={onClose}
        visible={visible}
      >
        {renderTypeForm(typeFormURL)}
      </Drawer>
    </div>
  );
};

const AutomotiveRoadsideAffiliatePage: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <AffiliateContent />
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default AutomotiveRoadsideAffiliatePage;
